var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _polygon, _path10, _path11, _path12, _polygon2, _polygon3, _polygon4, _path13, _path14, _path15, _path16, _path17, _polygon5, _polygon6, _polygon7, _polygon8, _polygon9, _polygon10, _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _ellipse7, _ellipse8, _ellipse9, _ellipse10, _ellipse11, _ellipse12, _ellipse13, _path18, _path19, _path20, _path21, _path22, _polygon11, _path23, _path24, _path25, _polygon12, _polygon13, _polygon14, _path26, _path27, _path28, _path29, _path30, _polygon15, _polygon16, _polygon17, _polygon18, _polygon19, _polygon20, _ellipse14, _ellipse15, _ellipse16, _ellipse17, _ellipse18, _ellipse19, _ellipse20, _ellipse21, _ellipse22, _ellipse23, _ellipse24, _ellipse25, _ellipse26, _path31, _path32, _path33, _path34, _path35, _ellipse27, _circle, _path36, _path37, _path38, _polygon21, _polygon22, _polygon23, _path39, _path40, _path41, _path42, _path43, _polygon24, _path44, _ellipse28, _circle2, _path45, _path46, _path47, _polygon25, _polygon26, _polygon27, _path48, _path49, _path50, _path51, _path52, _polygon28;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSydlogocolor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 321.92 321.92",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#010101;}.cls-2{fill:#fff;}.cls-3{fill:#070b04;}.cls-4{fill:#da6800;}.cls-5{fill:#030303;}.cls-6{fill:#bec3b8;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M255.12,249.49c-2.78,0-5.19-2.24-6-3.11l-15.35-10.63-.12-.11c-1.91-1.74-3.22-4.86-1.57-7.6.5-.83,1.28-1.9,2.11-3,.62-.84,1.55-2.09,2.09-3-1.92-2.4-6.4-8-9.48-11.93l-9.52,8.26,0,0c-9.34,7.6-17.08,12.81-24.35,16.39-8.57,4.23-16.71,6.28-24.88,6.28a53.72,53.72,0,0,1-19.08-3.63c-14.91-5.55-30.33-17.28-40.56-27.1-3.71,4.68-7.57,9.55-9.3,11.71.54.86,1.47,2.11,2.09,3,.83,1.12,1.61,2.19,2.11,3,1.65,2.74.34,5.86-1.57,7.6l-.12.11L86.23,246.38c-.83.88-3.23,3.11-6,3.11a5,5,0,0,1-3-1,.84.84,0,0,0-.33-.18,3.09,3.09,0,0,0-.44,0,7.82,7.82,0,0,1-1.09.1,5.05,5.05,0,0,1-4.12-2.32,9.16,9.16,0,0,1-1.8-5.64c-9.8-2.14-14-7.84-14.46-8.42-6.26-8.7-6.1-16.54-5.37-20.63a6.94,6.94,0,0,1-4.69-6,25.4,25.4,0,0,1,.13-3.78c0-.52.09-1,.09-1.41,0-2.5,2.61-4.52,3.75-5.29.72-.5,11.83-8.25,16.09-10.87A7.9,7.9,0,0,1,69,182.79a6.49,6.49,0,0,1,5.6,3.49l2.61,3.92c16.31-1.63,31.15-12.73,36.52-17.2.2-8.34,0-18.38-1.23-22.76-.94-3.43-1.84-4.82-2.42-5.38a2.13,2.13,0,0,0-1.62-.55,4.24,4.24,0,0,1-3-1.49,5,5,0,0,1-.56-.85,11.92,11.92,0,0,1-4.19,4.13,4.6,4.6,0,0,1-2,.44,7.54,7.54,0,0,1-4.36-1.7c-4.74-3.26-42.51-29.27-44.71-31-4.86-3.89-1.43-14.66,10.49-32.92,14.18-21.73,21.64-26.51,26-28.21A9.29,9.29,0,0,1,89.5,52a7.72,7.72,0,0,1,5.41,2.17c3.4,2.31,37.65,25.54,40.75,27.79.39.29.77.55,1.12.8,2.76,2,5.36,3.82,4.17,6.91a16.43,16.43,0,0,1-2.9,4.07c-2.57,2.8-4,3.16-5,3.16a3.06,3.06,0,0,1-2.2-.91,12,12,0,0,0-2.8.89,35.17,35.17,0,0,0-6.9,4.5c2.39,2.36,7.45,5.87,13.77,9.52a127.24,127.24,0,0,0,20.57-7.68l1.25-.57a29.76,29.76,0,0,0,6-4.14c2.07-1.7,3.43-2.82,5-2.82H168c1.91.15,3.42,1.43,5.16,2.91l1.41,1.17a93.48,93.48,0,0,0,9.73,5.52,130.77,130.77,0,0,0,16.09,5.38c6.23-3.62,11.07-7,13.39-9.29a33.94,33.94,0,0,0-6.9-4.51,12,12,0,0,0-2.8-.89,3.06,3.06,0,0,1-2.2.91c-1,0-2.46-.36-5-3.16a16.69,16.69,0,0,1-2.9-4.07c-1.18-3.09,1.42-5,4.17-6.91l1.13-.8c3.09-2.25,37.34-25.48,40.74-27.79A7.72,7.72,0,0,1,245.39,52a9.29,9.29,0,0,1,3.33.65c4.38,1.7,11.83,6.48,26,28.21,11.91,18.26,15.34,29,10.48,32.92-2.2,1.76-40,27.77-44.71,31a7.54,7.54,0,0,1-4.36,1.7,4.66,4.66,0,0,1-2-.44A12,12,0,0,1,230,142a4.93,4.93,0,0,1-4.09,2.33h-.35a1.36,1.36,0,0,0-.62.22c-.2.22-1.64,2.09-2.75,11.63-.59,5-.8,9.78-.82,10.44.06,2.29.18,4.47.35,6.49,5.31,4.38,20.15,15.44,36.37,17.07l2.61-3.92a6.49,6.49,0,0,1,5.6-3.49,7.9,7.9,0,0,1,4.11,1.29c4.26,2.62,15.36,10.36,16.08,10.87,1.15.77,3.76,2.79,3.76,5.29,0,.44,0,.89.09,1.41a25.4,25.4,0,0,1,.13,3.78,7,7,0,0,1-4.69,6c.73,4.09.89,11.93-5.37,20.63-.42.58-4.66,6.28-14.46,8.42a9.16,9.16,0,0,1-1.8,5.64,5.05,5.05,0,0,1-4.12,2.32,7.53,7.53,0,0,1-1.09-.1,3.25,3.25,0,0,0-.44,0,.84.84,0,0,0-.33.18A5,5,0,0,1,255.12,249.49Zm-30.2-104.9h0ZM104,133.26c.09.17.18.32.27.48V129.2C103.72,132.21,104,133.11,104,133.26Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M287.72,200.24c0-1.43-2.65-3.19-2.65-3.19s-11.69-8.16-16-10.81-6.17,1.33-6.17,1.33l-3.53,5.29c-18.29-1.18-34.86-14-40.08-18.45-.23-2.3-.39-4.88-.47-7.79,0,0,.78-21,4.52-24a3.84,3.84,0,0,1,2.43-.78c1.32.11,2.76-1.32,2.76-3.41s-.22-16.65-.22-16.65a4.06,4.06,0,0,0,0-.42,3.17,3.17,0,0,1,2.31-.68,14,14,0,0,1,1.55,4c.77,2.86,2,7.93,1,9.81s-2.21,3-2,4.19,2.43,4.41,4.08,5.18,3.75-1,3.75-1,42.45-29.22,44.65-31,2.65-8.6-11-29.55S251.77,56.59,247.8,55.05a5.39,5.39,0,0,0-6.17,1.1s-37.71,25.58-40.9,27.9-5,3.3-4.41,4.74,5.18,6.94,6.06,5.29,5.62.55,5.62.55c8.49,4.52,9,6.83,9,6.83-2.49,3.83-12.51,9.8-16.29,12a133.07,133.07,0,0,1-17.52-5.79s-8-4.08-10.26-5.84-3.75-3.42-5.18-3.53-5.4,4.63-10,6.72a135,135,0,0,1-23.21,8.67c-3.42-1.94-14.12-8.23-16.7-12.2,0,0,.55-2.31,9-6.83,0,0,4.74-2.21,5.62-.55s5.51-3.86,6.07-5.29-1.22-2.43-4.41-4.74-40.91-27.9-40.91-27.9a5.39,5.39,0,0,0-6.17-1.1c-4,1.54-11.13,6.28-24.8,27.23s-13.23,27.78-11,29.55,44.65,31,44.65,31,2.09,1.76,3.75,1,3.86-4,4.08-5.18-1-2.32-2-4.19.22-7,1-9.81a13.88,13.88,0,0,1,1.54-4,3.24,3.24,0,0,1,2.82,1.15c-.21,2.58-.29,5.2-.29,5.2v11.69s-.29,2.94,1.84,3.09,4.34.59,6.32,7.79c1.69,6.12,1.41,20.47,1.29,24.64-4.94,4.24-21.74,17.45-40.31,18.65l-3.53-5.29s-1.88-4-6.18-1.33-16,10.81-16,10.81-2.65,1.76-2.65,3.19-.33,2.65-.22,5.08,2.76,4.19,5.29,4.08c0,0-4,9.7,4.3,21.16,0,0,4.3,6.29,15.22,7.83a7.28,7.28,0,0,0,1,6.17c2.09,2.76,3.09,0,5.51,1.88s5.84-2,5.84-2L100,233.76s2.42-2.21,1.1-4.41-5.51-7.06-4.85-7.83c.53-.61,8.63-10.84,11.89-15,8.91,8.94,25.33,22.41,41.69,28.51,24.25,9,43.44-.44,65.82-18.63l11.5-10c3.2,4.05,11.43,14.42,12,15s-3.53,5.62-4.85,7.83,1.1,4.41,1.1,4.41l15.43,10.69s3.42,3.86,5.85,2,3.41.88,5.51-1.88a7.32,7.32,0,0,0,1-6.17c10.92-1.54,15.21-7.83,15.21-7.83,8.27-11.46,4.3-21.16,4.3-21.16,2.54.11,5.19-1.66,5.3-4.08S287.72,201.68,287.72,200.24Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M110.5,122.9v15.79h0a5.15,5.15,0,0,1,4.17,2.13c2.16,2.94,5.27,9.43,5.27,22.27,0,18.63-3.08,32-12.91,34.9a1,1,0,0,0-.41,1.61c6.6,6.54,38.56,36.82,62.27,35.15,25.18-1.77,53.53-27.91,59.81-35.42a.75.75,0,0,0-.41-1.2c-2.51-.56-8.23-3.32-11.44-16.74-4.19-17.53-.88-41.89,7.72-42.88V123.35a1.94,1.94,0,0,0-1.79-1.94c-7.41-.57-36.1-3.67-53.79-17.87a2,2,0,0,0-2.63.12c-3.77,3.6-17.3,13.6-54.24,17.45A1.8,1.8,0,0,0,110.5,122.9Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M114.1,124.84v10.69s7.5,5.29,8.82,19.29c1.29,13.62.18,33.69-9.92,43.81a1.35,1.35,0,0,0,0,1.83c4.87,5.63,30.38,33.36,58.92,31,0,0,23.44-2.38,51-31.05a.86.86,0,0,0-.06-1.25c-2.74-2.3-12.17-12.38-10.85-40.9,0,0,.33-13.67,9.15-22.93V125s-34.18-3.64-53.8-18C167.35,107,147.73,121.2,114.1,124.84Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M117.63,127.92v5.52s12,10.58,9.92,37c0,0-1.14,19.55-8.83,28.49a1.26,1.26,0,0,0,.06,1.69c4.74,4.87,29.15,28.71,50.44,26.93,21.48-1.8,43.86-23.33,47.88-27.36a.87.87,0,0,0,0-1.22c-2.21-2.21-9.36-11.28-9.17-36.36,0,0-.33-18.3,9.48-28.66V127.7s-34.51-3.75-49.61-16A97.73,97.73,0,0,1,117.63,127.92Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M146.51,155.71h8.38V139.17s-.66-14-8.93-13.89-11.68,8.27-12.79,20.83,1.44,21.06,8.38,32.2,6.29,22.82,2.54,23.37-3.86-13.56-3.2-17.42l-8.6-2L132.18,194s-.11,22.16,14.11,23.92,9.37-35.16,6.07-42.88-12.24-20.73-11.69-29.22S148.39,137.85,146.51,155.71Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M157.43,123s7.16-1.43,8.71-.88l2.42,33.18,2.54-33.51s8.05.88,8.71,2l-6.62,53.69v45.76a20.63,20.63,0,0,1-9,.44L163.82,177Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M204.5,180.62c-.22-14.22-.55-37.15-.55-37.15s3.09-16.21-21.72-19.41v96.69s13.23-5.95,16.76-11.58S204.72,194.84,204.5,180.62ZM196,194.18c-.22,3.86-2.31,6.29-3.85,6.29s-1.77-2.32-1.77-2.32l.11-55.89c1.66-.78,2.32-.34,2.32-.34C196,143,196,150.08,196,150.08S196.23,190.32,196,194.18Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M135.05,87.9,133.17,91s-3.63-1.43-5.73-1.21-10.47,3.53-18,12-11.24,18-11.8,24.69-.11,8.82,1.88,10.36c0,0,1.54,1.33.44,2.65l-1.1,1.32s.11.11-2.87-1.76-24-16.32-24-16.32,4.3-28.39,35.88-52.7Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "133.06 88.73 132.68 89.61 128.03 88.13 105.76 73.06 107.52 71.29 133.06 88.73"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M124.94,88.79s-9.41,4.41-12.49,8.45l-18.6-12,1.69-2.43L106,89.89l-9.7-8,7.86-7.5Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M99.36,90.4l-6-4.19-6,7.06,1.91.22S90.32,88.93,99.36,90.4Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M104.14,93.71l6.91,4.78-5.22,6.17S107.74,101.06,104.14,93.71Z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "96.72 119.73 97.53 118.77 97.38 122.08 96.06 121.93 78.27 109.66 78.49 107.38 79.96 107.01 79.96 109.22 96.72 119.73"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "96.79 123.4 96.35 130.09 77.76 116.42 74.89 116.2 77.46 110.32 96.79 123.4"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "74.16 120.02 99.66 137.96 98.56 139.28 73.2 121.86 74.16 120.02"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M106.05,68.39l-3.08-2S72.32,89.34,67.36,119.54l2.2,1.55S77.94,90.38,106.05,68.39Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M100.76,64.64l-3.09-2S67,85.59,62.06,115.8l2.21,1.54S72.65,86.64,100.76,64.64Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M95.36,60.78l-5.73-3.63a5.78,5.78,0,0,0-3.75,1.65c-1.66,1.65-30.21,28.77-32.52,50.93l5.84,4S66.31,85.75,95.36,60.78Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M108.51,118.79a.75.75,0,0,0-.42-.74c-1-.51-3.92-2-4.24-1.59S108.31,120.23,108.51,118.79Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M95.84,91.36a9.26,9.26,0,1,0,9.26,9.26A9.25,9.25,0,0,0,95.84,91.36Zm.33,16.17a7.13,7.13,0,1,1,7.24-7.13A7.18,7.18,0,0,1,96.17,107.53Z"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "59.2 97.83 63.17 100.25 60.52 104.99 57.66 102.79 55.78 103.01 58.98 96.39 59.2 97.83"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "59.16 109.95 58.35 111.86 54.38 109 55.12 106.87 59.16 109.95"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "73.86 73.57 78.16 76.55 73.2 83.38 68.57 80.41 73.86 73.57"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "76.21 70.63 80.7 73.5 79.52 74.89 75.04 71.88 76.21 70.63"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "84.74 61.37 89.22 64.46 82.53 71.59 77.98 68.57 84.74 61.37"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "88.63 58.36 93.04 61.23 91.28 63.06 86.65 59.61 88.63 58.36"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-6",
    cx: 96.89,
    cy: 65.51,
    rx: 1.23,
    ry: 0.47,
    transform: "translate(-19.07 80.77) rotate(-41.56)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-6",
    cx: 102.07,
    cy: 69.26,
    rx: 1.23,
    ry: 0.47,
    transform: "translate(-20.25 85.15) rotate(-41.56)"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-6",
    cx: 84.78,
    cy: 77.25,
    rx: 1.23,
    ry: 0.47,
    transform: "translate(-29.91 78.08) rotate(-42.76)"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-6",
    cx: 90.19,
    cy: 81,
    rx: 1.23,
    ry: 0.47,
    transform: "translate(-31.02 82.76) rotate(-42.76)"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-6",
    cx: 63.76,
    cy: 114.51,
    rx: 1.23,
    ry: 0.47,
    transform: "translate(-63.92 144.12) rotate(-73.95)"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-6",
    cx: 69.24,
    cy: 117.7,
    rx: 1.23,
    ry: 0.47,
    transform: "translate(-63.02 151.7) rotate(-73.95)"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-6",
    cx: 74.09,
    cy: 104.64,
    rx: 1.23,
    ry: 0.47,
    transform: "translate(-53.58 116.48) rotate(-60)"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-6",
    cx: 90.21,
    cy: 71.55,
    rx: 5.22,
    ry: 0.47,
    transform: "translate(-24.17 84.75) rotate(-45)"
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-6",
    cx: 95.95,
    cy: 74.97,
    rx: 5.22,
    ry: 0.47,
    transform: "translate(-24.91 89.8) rotate(-45)"
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-6",
    cx: 80.02,
    cy: 83.25,
    rx: 5.22,
    ry: 0.47,
    transform: "translate(-35.16 91.48) rotate(-50.22)"
  })), _ellipse11 || (_ellipse11 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-6",
    cx: 85.08,
    cy: 87.22,
    rx: 5.22,
    ry: 0.47,
    transform: "translate(-36.39 96.8) rotate(-50.22)"
  })), _ellipse12 || (_ellipse12 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-6",
    cx: 66.61,
    cy: 106.18,
    rx: 2.84,
    ry: 0.66,
    transform: "translate(-57.64 122.68) rotate(-65.46)"
  })), _ellipse13 || (_ellipse13 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-6",
    cx: 71.8,
    cy: 109.82,
    rx: 2.84,
    ry: 0.66,
    transform: "translate(-57.92 129.52) rotate(-65.46)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M126.23,115.58a37.47,37.47,0,0,1-16.06,2,14.29,14.29,0,0,1-5.22-3s.44-4.55,7.35-9.48Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M115.31,101.46a37.63,37.63,0,0,0,14.45,12.68s-.78,2-3.53,1.44l-14.78-11,1.11-1,9.81,7.28s-7.17-6.51-8.16-8.82Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M106.73,114l3.35,2.56a.75.75,0,0,1-.38,1.33h0a.71.71,0,0,1-.52-.15l-3.31-2.57a.74.74,0,0,1-.23-.85h0A.74.74,0,0,1,106.73,114Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M121.12,115.39s2.06-.51,2.43.22-2.94,1.47-4,1.25S121.12,115.39,121.12,115.39Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M200.42,87.9,202.3,91s3.64-1.43,5.73-1.21,10.47,3.53,18,12,11.25,18,11.8,24.69.11,8.82-1.88,10.36c0,0-1.54,1.33-.44,2.65l1.1,1.32s-.11.11,2.87-1.76,24-16.32,24-16.32S259.18,94.35,227.6,70Z"
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "202.41 88.73 202.79 89.61 207.44 88.13 229.71 73.06 227.95 71.29 202.41 88.73"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M210.53,88.79s9.41,4.41,12.49,8.45l18.6-12-1.69-2.43-10.44,7.06,9.7-8-7.86-7.5Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M236.11,90.4l6-4.19,6,7.06-1.91.22S245.15,88.93,236.11,90.4Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M231.33,93.71l-6.91,4.78,5.22,6.17S227.73,101.06,231.33,93.71Z"
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "238.75 119.73 237.94 118.77 238.09 122.08 239.41 121.93 257.2 109.66 256.98 107.38 255.51 107.01 255.51 109.22 238.75 119.73"
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "238.68 123.4 239.12 130.09 257.71 116.42 260.58 116.2 258.01 110.32 238.68 123.4"
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "261.32 120.02 235.81 137.96 236.91 139.28 262.27 121.86 261.32 120.02"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M229.42,68.39l3.09-2s30.64,22.93,35.6,53.13l-2.2,1.55S257.53,90.38,229.42,68.39Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M234.71,64.64l3.09-2s30.65,22.93,35.61,53.14l-2.21,1.54S262.82,86.64,234.71,64.64Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M240.11,60.78l5.73-3.63a5.78,5.78,0,0,1,3.75,1.65c1.66,1.65,30.21,28.77,32.53,50.93l-5.85,4S269.16,85.75,240.11,60.78Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M227,118.79a.75.75,0,0,1,.42-.74c1-.51,3.92-2,4.24-1.59S227.16,120.23,227,118.79Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M230.37,100.62a9.26,9.26,0,1,0,9.26-9.26A9.27,9.27,0,0,0,230.37,100.62Zm1.69-.22a7.24,7.24,0,1,1,7.24,7.13A7.19,7.19,0,0,1,232.06,100.4Z"
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "276.27 97.83 272.3 100.25 274.95 104.99 277.82 102.79 279.69 103.01 276.49 96.39 276.27 97.83"
  })), _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "276.31 109.95 277.12 111.86 281.09 109 280.35 106.87 276.31 109.95"
  })), _polygon17 || (_polygon17 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "261.61 73.57 257.31 76.55 262.27 83.38 266.9 80.41 261.61 73.57"
  })), _polygon18 || (_polygon18 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "259.26 70.63 254.78 73.5 255.95 74.89 260.43 71.88 259.26 70.63"
  })), _polygon19 || (_polygon19 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "250.73 61.37 246.25 64.46 252.94 71.59 257.49 68.57 250.73 61.37"
  })), _polygon20 || (_polygon20 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "246.84 58.36 242.43 61.23 244.19 63.06 248.82 59.61 246.84 58.36"
  })), _ellipse14 || (_ellipse14 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-6",
    cx: 238.58,
    cy: 65.51,
    rx: 0.47,
    ry: 1.23,
    transform: "translate(31.28 200.56) rotate(-48.44)"
  })), _ellipse15 || (_ellipse15 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-6",
    cx: 233.4,
    cy: 69.26,
    rx: 0.47,
    ry: 1.23,
    transform: "translate(26.73 197.95) rotate(-48.44)"
  })), _ellipse16 || (_ellipse16 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-6",
    cx: 250.7,
    cy: 77.25,
    rx: 0.47,
    ry: 1.23,
    transform: "translate(23.78 208.88) rotate(-47.24)"
  })), _ellipse17 || (_ellipse17 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-6",
    cx: 245.28,
    cy: 81,
    rx: 0.47,
    ry: 1.23,
    transform: "translate(19.29 206.1) rotate(-47.24)"
  })), _ellipse18 || (_ellipse18 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-6",
    cx: 271.72,
    cy: 114.51,
    rx: 0.47,
    ry: 1.23,
    transform: "translate(-21.07 79.58) rotate(-16.05)"
  })), _ellipse19 || (_ellipse19 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-6",
    cx: 266.23,
    cy: 117.7,
    rx: 0.47,
    ry: 1.23,
    transform: "translate(-22.16 78.19) rotate(-16.05)"
  })), _ellipse20 || (_ellipse20 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-6",
    cx: 261.38,
    cy: 104.64,
    rx: 0.47,
    ry: 1.23,
    transform: "translate(-17.3 144.71) rotate(-30)"
  })), _ellipse21 || (_ellipse21 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-6",
    cx: 245.26,
    cy: 71.55,
    rx: 0.47,
    ry: 5.22,
    transform: "translate(21.24 194.38) rotate(-45)"
  })), _ellipse22 || (_ellipse22 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-6",
    cx: 239.52,
    cy: 74.97,
    rx: 0.47,
    ry: 5.22,
    transform: "translate(17.14 191.33) rotate(-45)"
  })), _ellipse23 || (_ellipse23 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-6",
    cx: 255.46,
    cy: 83.25,
    rx: 0.47,
    ry: 5.22,
    transform: "translate(5.87 182.72) rotate(-39.78)"
  })), _ellipse24 || (_ellipse24 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-6",
    cx: 250.39,
    cy: 87.22,
    rx: 0.47,
    ry: 5.22,
    transform: "translate(2.16 180.4) rotate(-39.78)"
  })), _ellipse25 || (_ellipse25 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-6",
    cx: 268.86,
    cy: 106.18,
    rx: 0.66,
    ry: 2.84,
    transform: "translate(-19.81 121.24) rotate(-24.54)"
  })), _ellipse26 || (_ellipse26 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-6",
    cx: 263.67,
    cy: 109.82,
    rx: 0.66,
    ry: 2.84,
    transform: "translate(-21.79 119.42) rotate(-24.54)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M209.24,115.58a37.47,37.47,0,0,0,16.06,2,14.29,14.29,0,0,0,5.22-3s-.44-4.55-7.35-9.48Z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M220.16,101.46a37.64,37.64,0,0,1-14.44,12.68s.77,2,3.52,1.44l14.78-11-1.11-1-9.81,7.28s7.17-6.51,8.16-8.82Z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M228.74,114l-3.35,2.56a.75.75,0,0,0,.38,1.33h0a.7.7,0,0,0,.52-.15l3.31-2.57a.74.74,0,0,0,.23-.85h0A.74.74,0,0,0,228.74,114Z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M214.35,115.39s-2.06-.51-2.42.22,2.94,1.47,4,1.25S214.35,115.39,214.35,115.39Z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M114.43,179.63S114.54,187,111,191l-5.18,1.88L99.77,196s-2.21,1.54-2,2.75,6.73,4.63,6.62,6.06-5.73,6.84-7.28,8.93a4.69,4.69,0,0,1-3.75,2,33.37,33.37,0,0,0-1.1-6.51c-.77-2.09-5.4-7.27-8.38-9.37s-.55-4.08,2.87-4.63S111.12,186.68,114.43,179.63Z"
  })), _ellipse27 || (_ellipse27 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-6",
    cx: 74.25,
    cy: 216.03,
    rx: 18.14,
    ry: 17.62
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 74.63,
    cy: 216.18,
    r: 11.96
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M114.43,179.63l-.77,3.31S99.11,194.07,84,197.27c0,0-.44.88,1,1.54s6.28,4.74,7.71,8.93.55,5.51,1.77,6.07,4.52-5.85,5.4-6.73,3.64-3.86,4.63-2.76-7.28,10.37-7.28,10.37-4.74,5.73-3.86,7.6,6.4,7.72,4.3,9.93-7.93,5.29-7.93,5.29l-4.41-7.72s8.93-5.4,6.61-17.42-16.09-17.2-26.68-11.79l-5.07-6.84s8.27-6.5,9-5.62,5.18,7.16,5.18,7.16.88,1,3.53.89S98.89,193.3,114.43,179.63Z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M112.26,186.61S101.09,195.39,96,196.72c-4.59,1.19-1.5,5.82,2.06,7.83a3.14,3.14,0,0,0,2.38.29,4.65,4.65,0,0,0,1.29-.52,4.37,4.37,0,0,0,1.11-1.18,1.61,1.61,0,0,0-.16-2,5,5,0,0,1-1.5-2.72c-.22-2,1-4,3.86-3.86S112.85,190.62,112.26,186.61Z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M84.22,231l4.41,7.06-7.71,5.51-6-8.27s-6.89,1.25-13.4-4.72a20.69,20.69,0,0,1-5.87-20.41c.16-.6.33-1.22.53-1.88l-5.62-8.16L59,194.84l4.85,6.62s-7.61,6.61-7.72,14.66S63,233.54,75.18,233.43A20,20,0,0,0,84.22,231Z"
  })), _polygon21 || (_polygon21 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "52 200.54 58.83 195.98 61.37 199.4 54.53 204.36 52 200.54"
  })), _polygon22 || (_polygon22 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "87.94 238.06 81.1 242.62 78.56 239.2 85.4 234.24 87.94 238.06"
  })), _polygon23 || (_polygon23 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "61.84 193.89 68.68 189.33 71.22 192.75 64.38 197.71 61.84 193.89"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M65.87,201.79l1,1.16a16,16,0,0,1,5.34-2.65S71,199,65.87,201.79Z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M64.78,202.56l.81,1.25s-10.14,7.42-3.38,20.43c0,0,6.47,10.73,20.8,4.34l.59,1.1s-13.52,8.23-23.15-5.44C60.45,224.24,53.61,212.26,64.78,202.56Z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M83.89,227.84l.74,1.18s4.63-3.75,4.56-6.47Z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M70.3,197.49s1.69-1.77,1.32-3.09c0,0,1.54,0,2.42,3.31A7.56,7.56,0,0,1,70.3,197.49Z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M90.17,226s1.8-1.65,1.51-3c0,0,1.54.09,2.22,3.45A7.52,7.52,0,0,1,90.17,226Z"
  })), _polygon24 || (_polygon24 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "87.86 232.38 90.18 236.07 97.51 231.22 95.08 227.15 87.86 232.38"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M220.93,179.63s-.11,7.39,3.42,11.35l5.18,1.88,6.06,3.09s2.21,1.54,2,2.75-6.73,4.63-6.62,6.06,5.73,6.84,7.28,8.93a4.69,4.69,0,0,0,3.75,2,33.37,33.37,0,0,1,1.1-6.51c.77-2.09,5.4-7.27,8.38-9.37s.55-4.08-2.87-4.63S224.24,186.68,220.93,179.63Z"
  })), _ellipse28 || (_ellipse28 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-6",
    cx: 261.11,
    cy: 216.03,
    rx: 18.14,
    ry: 17.62
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 260.73,
    cy: 216.18,
    r: 11.96
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M220.93,179.63l.77,3.31s14.55,11.13,29.66,14.33c0,0,.44.88-1,1.54s-6.29,4.74-7.72,8.93-.55,5.51-1.77,6.07-4.52-5.85-5.4-6.73-3.64-3.86-4.63-2.76,7.28,10.37,7.28,10.37,4.74,5.73,3.86,7.6-6.4,7.72-4.3,9.93,7.93,5.29,7.93,5.29l4.41-7.72s-8.93-5.4-6.61-17.42,16.1-17.2,26.68-11.79l5.07-6.84s-8.27-6.5-9-5.62-5.18,7.16-5.18,7.16-.88,1-3.53.89S236.47,193.3,220.93,179.63Z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M223.1,186.61s11.17,8.78,16.24,10.11c4.59,1.19,1.51,5.82-2.06,7.83a3.14,3.14,0,0,1-2.38.29,4.78,4.78,0,0,1-1.29-.52,4.37,4.37,0,0,1-1.11-1.18,1.61,1.61,0,0,1,.16-2,4.89,4.89,0,0,0,1.5-2.72c.22-2-1-4-3.86-3.86S222.51,190.62,223.1,186.61Z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M251.14,231l-4.41,7.06,7.71,5.51,6-8.27s6.89,1.25,13.4-4.72a20.69,20.69,0,0,0,5.87-20.41c-.16-.6-.33-1.22-.53-1.88l5.62-8.16-8.38-5.29-4.85,6.62s7.61,6.61,7.72,14.66-6.84,17.42-19.07,17.31A20,20,0,0,1,251.14,231Z"
  })), _polygon25 || (_polygon25 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "283.37 200.54 276.53 195.98 274 199.4 280.83 204.36 283.37 200.54"
  })), _polygon26 || (_polygon26 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "247.43 238.06 254.26 242.62 256.8 239.2 249.96 234.24 247.43 238.06"
  })), _polygon27 || (_polygon27 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "273.52 193.89 266.68 189.33 264.15 192.75 270.98 197.71 273.52 193.89"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M269.49,201.79l-1,1.16a16.09,16.09,0,0,0-5.35-2.65S264.37,199,269.49,201.79Z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M270.58,202.56l-.81,1.25s10.14,7.42,3.38,20.43c0,0-6.47,10.73-20.8,4.34l-.59,1.1s13.53,8.23,23.15-5.44C274.91,224.24,281.75,212.26,270.58,202.56Z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M251.47,227.84l-.74,1.18s-4.63-3.75-4.55-6.47Z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M265.06,197.49s-1.69-1.77-1.32-3.09c0,0-1.54,0-2.42,3.31A7.56,7.56,0,0,0,265.06,197.49Z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M245.19,226s-1.8-1.65-1.51-3c0,0-1.54.09-2.22,3.45A7.52,7.52,0,0,0,245.19,226Z"
  })), _polygon28 || (_polygon28 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "247.5 232.38 245.18 236.07 237.85 231.22 240.28 227.15 247.5 232.38"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSydlogocolor);
export default __webpack_public_path__ + "static/media/sydlogocolor.c875554059e76ecb1e43872b25eb4c19.svg";
export { ForwardRef as ReactComponent };